import AcceptedNotif from '@/assets/smartcity/accepted-notif.svg';
import InfoNotif from '@/assets/smartcity/info-notif.svg';
import RejectedNotif from '@/assets/smartcity/rejected-notif.svg';
import SuccessNotif from '@/assets/smartcity/success-notif.svg';
import UpdateNotif from '@/assets/smartcity/update-notif.svg';
import { cn } from '@/lib/utils';

const typeNotif = {
  success: {
    icon: SuccessNotif,
  },
  info: {
    icon: InfoNotif,
  },
  accept: {
    icon: AcceptedNotif,
  },
  reject: {
    icon: RejectedNotif,
  },
  update: {
    icon: UpdateNotif,
  },
};

type NotifType = keyof typeof typeNotif;

interface NotifCardProps {
  icon: NotifType;
  title: string;
  desc: string;
  dateTime: string;
  reportId: string;
}

const NotifCard = ({ icon, title, desc, dateTime, reportId }: NotifCardProps) => {
  const typeCard = typeNotif[icon];

  return (
    <div
      className={cn(
        'w-full flex flex-row items-start justify-between gap-3 bg-db-card  dark:bg-[#F3F6FE]/10  border-b   p-3 '
      )}
    >
      <div className="w-fit flex flex-row gap-6 items-center">
        <img src={typeCard.icon} alt={icon} />
        <div className="flex flex-col">
          <span className="title1bold">{title}</span>
          <span className="text-db-text-grey title2">{desc}</span>
          <span className="text-db-text-grey title2">{dateTime}</span>
        </div>
      </div>
      <span className="title2 text-db-text-grey">{reportId}</span>
    </div>
  );
};

export default NotifCard;
